<template>
  <div>
    <v-form ref="form" @submit.prevent="submit">
      <v-text-field
        v-model="oldPassword"
        type="password"
        outlined
        label="Senha antiga"
        :rules="[$rules.required, $rules.minLengthPassword]"
      />
      <v-text-field
        v-model="newPassword"
        type="password"
        outlined
        label="Nova senha"
        :rules="[$rules.required, $rules.minLengthPassword]"
      />
      <v-text-field
        v-model="confirmNewPassword"
        type="password"
        outlined
        label="Repita a nova senha"
        :rules="[$rules.required, matchPassword]"
      />
      <v-btn block large color="secondary" type="submit">
        {{ buttonText }}
      </v-btn>
    </v-form>
  </div>
</template>

<script>
export default {
  name: "FormPassword",
  props: {
    buttonText: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    oldPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  }),
  computed: {
    matchPassword() {
      return (
        this.newPassword === this.confirmNewPassword ||
        "Campos de senhas diferentes."
      );
    },
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) return;
      this.$emit("submit", {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword,
        confirmNewPassword: this.confirmNewPassword,
      });
      this.clean();
    },
    clean() {
      this.$refs.form.reset();
    },
  },
};
</script>

<style scoped></style>
